module.exports = __webpack_public_path__ + "img/exclude-keyword.803ec06e.svg";